import { axios } from "axios";
import COLUMN_LIST_DATA from "../components/ProductCondition/data/columnListData";
import XLSX, { read } from 'xlsx-js-style'
import { roundNumber } from "./util";

export const inputExcelData = (file) => {
  let reader = new FileReader();
  if(file) {
    reader.readAsArrayBuffer(file)
    reader.onload = (e) => {
      let fileData = new Uint8Array(e.target.result);
      let wb = XLSX.read(fileData, {type: 'array', cellDates: true, dateNF: "yyyy-mm-dd"});
      wb.SheetNames.forEach((sheetName) => {
        let excel = XLSX.utils.sheet_to_json(wb.Sheets[sheetName], { header: 1});
        // if(excel.length > 0) {
        //   excel[0] = excel[0].map(header => 
        //     typeof header === 'string' ? header.replace(/\r?\n|\r/g, ' ') : header
        //   );
        // }
        excel.shift()
        console.log(excel)
      });
    }
  }
  return;
}

export const Excel = (data, columnList) => {
  if(!data) {
    return
  }
  const wb = XLSX.utils.book_new();
  let table = [];
  let row = [];
  columnList.forEach(e => {
    row.push({
      v: e,
      t: 's',
      s: {
        border: { 
          top: {
            style: "medium",
          },
          bottom: {
            style: "medium",
          },
          left: {
            style: "medium",
          },
          right: {
            style: "medium",
          }
        },
        fill: {
          patternType: "solid",
          fgColor: { rgb: "2563eb" },
        },
        font: {
          bold: true,
          sz: '11',
          name: '함초롱바탕',
          color: { rgb: "FFFFFFFF"}
        },
        alignment: { 
          wrapText: true,
          vertical: 'center',
          horizontal: 'center',

        }
      }
    })
  })

  table.push(row);
  const dataStyle = { 
    border: { 
      bottom: {
        style: "thin",
      },
      left: {
        style: "thin",
      },
      right: {
        style: "thin",
      }
    },
    font: { 
      name: '함초롱바탕' ,
      sz: '9'
    },
    alignment: { horizontal: "center"}
  }
  console.log(data);
  data.forEach(object => {
    const keys = Object.keys(object)
    const row = [];
    keys.forEach(key =>
      {
        console.log(object[`${key}`]);
        row.push({
          v: roundNumber(object[`${key}`]) ?? '',
          t: 's',
          s: dataStyle,
        })
      } 
    );
    // row = [
    //   {
    //     v: object.PPDATE ?? '',
    //     t: 's',
    //     s: dataStyle,
    //   },
    //   {
    //     v: object.PPTIME ?? '',
    //     t: 's',
    //     s: dataStyle,
    //   },
    //   {
    //     v: object.PKCDXX ?? '',
    //     t: 's',
    //     s: dataStyle,
    //   },
    //   {
    //     v: object.BSSWGH ?? '',
    //     t: 's',
    //     s: dataStyle,
    //   },
    //   {
    //     v: object.HOGIXX ?? '',
    //     t: 's',
    //     s: dataStyle,
    //   },
    //   {
    //     v: object.SPEEDX ?? '',
    //     t: 's',
    //     s: dataStyle,
    //   },
    //   {
    //     v: object.SBSSWG ?? '',
    //     t: 's',
    //     s: dataStyle,
    //   },
    //   {
    //     v: object.WATERX ?? '',
    //     t: 's',
    //     s: dataStyle,
    //   },
    //   {
    //     v: object.THICKX ?? '',
    //     t: 's',
    //     s: dataStyle,
    //   },
    //   {
    //     v: object.MILDOX ?? '',
    //     t: 's',
    //     s: dataStyle,
    //   },
    //   {
    //     v: object.MDABGA ?? '',
    //     t: 's',
    //     s: dataStyle,
    //   },
    //   {
    //     v: object.CDABGA ?? '',
    //     t: 's',
    //     s: dataStyle,
    //   },
    //   {
    //     v: object.CDINDX ?? '',
    //     t: 's',
    //     s: dataStyle,
    //   },
    //   {
    //     v: object.MDCDXX ?? '',
    //     t: 's',
    //     s: dataStyle,
    //   },
    //   {
    //     v: object.PAGANG ?? '',
    //     t: 's',
    //     s: dataStyle,
    //   },
    //   {
    //     v: object.PAINDX ?? '',
    //     t: 's',
    //     s: dataStyle,
    //   },
    //   {
    //     v: object.COBBTE ?? '',
    //     t: 's',
    //     s: dataStyle,
    //   },
    //   {
    //     v: object.COBBDE ?? '',
    //     t: 's',
    //     s: dataStyle,
    //   },
    //   {
    //     v: object.COBBSI ?? '',
    //     t: 's',
    //     s: dataStyle,
    //   },
    //   {
    //     v: object.COLORL ?? '',
    //     t: 's',
    //     s: dataStyle,
    //   },
    //   {
    //     v: object.COLORA ?? '',
    //     t: 's',
    //     s: dataStyle,
    //   },
    //   {
    //     v: object.COLORB ?? '',
    //     t: 's',
    //     s: dataStyle,
    //   },
    // ];
    table.push(row);
  })
  // let row = [
  //   { v: "Courier: 24", t: "s", s: { font: { name: "Courier", sz: 24 } } },
  //   { v: "bold & color", t: "s", s: { font: { bold: true, color: { rgb: "FF0000" } } } },
  //   { v: "fill: color", t: "s", s: { fill: { fgColor: { rgb: "E9E9E9" } } } },
  //   { v: "line\nbreak", t: "s", s: { alignment: { wrapText: true } } },
  // ];

  const ws = XLSX.utils.aoa_to_sheet(table);

  let cols = []
  for(let i = 0; i < columnList.length; i++) {
    cols.push({wpx: 120});
  }
  ws["!cols"] = cols;
  ws["!rows"] = [{hpx: 40}]
  XLSX.utils.book_append_sheet(wb, ws, "실험 결과");

  XLSX.writeFile(wb, "실험결과.xlsx")
}